import { RecettesService } from '../services/RecettesService'
import KeyboardService from '@/services/KeyboardService'

export const state = {
  recettes: [],
  loader: false,
  dialog: false,
  recetteDialog: {},
}
export const mutations = {
  setRecettes(currentState, recettes) {
    currentState.recettes.recettes = recettes
  },
  setRecettesLoading(currentState, bool) {
    currentState.recettes.loader = bool
  },
  setRecetteDialogState(currentState, bool) {
    currentState.recettes.dialog = bool
  },
  setRecetteDialog(currentState, recette) {
    currentState.recettes.recetteDialog = recette
  },
}
export const actions = {

  setRecetteDialogState({ commit }, bool) {
    commit('setRecetteDialogState', bool)
  },
  setRecetteDialog({ commit }, recette) {
    commit('setRecetteDialog', recette)
  },
  loadAllRecettes({ commit }, keyboard) {
    commit('setRecettesLoading', true)
    RecettesService.getAllRecettes()
      .then(recettes => {
        if (recettes.message) {
          return []
        }

        return recettes.map(recette => ({
          ...recette,
          plu: recette.codeMagasin.map(code => code.plu).join(' ,'),
          codeProduit: recette.codeProduit.map(code => ({
            ...code,
            text: KeyboardService.retreiveSentence(code, keyboard, false, recette.codeMagasin[0] ? recette.codeMagasin[0].idCodeMagasin : null),
          })),
        }))
      }).then((recettes) => {
        commit('setRecettesLoading', false)
        commit('setRecettes', recettes)
      })
  },
}
export default { state, actions, mutations }
